import { render, staticRenderFns } from "./c-search.vue?vue&type=template&id=08b9c5c7&scoped=true"
import script from "./c-search.vue?vue&type=script&lang=js"
export * from "./c-search.vue?vue&type=script&lang=js"
import style0 from "./c-search.vue?vue&type=style&index=0&id=08b9c5c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b9c5c7",
  null
  
)

export default component.exports